/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddCommentRequest } from '../model';
// @ts-ignore
import type { BulkUpdateControlRequest } from '../model';
// @ts-ignore
import type { Comment } from '../model';
// @ts-ignore
import type { ControlPaginated } from '../model';
// @ts-ignore
import type { ControlStatus } from '../model';
// @ts-ignore
import type { ControlsSorting } from '../model';
// @ts-ignore
import type { Framework } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { Log } from '../model';
// @ts-ignore
import type { Requirement } from '../model';
// @ts-ignore
import type { UpdateRequirementOwnershipRequest } from '../model';
// @ts-ignore
import type { UpdateRequirementStatusRequest } from '../model';
/**
 * RequirementsApi - axios parameter creator
 */
export const RequirementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Bulk Update Requirements Controls
         * @param {string} requirementId 
         * @param {BulkUpdateControlRequest} bulkUpdateControlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateRequirementsControls: async (requirementId: string, bulkUpdateControlRequest: BulkUpdateControlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requirementId' is not null or undefined
            assertParamExists('bulkUpdateRequirementsControls', 'requirementId', requirementId)
            // verify required parameter 'bulkUpdateControlRequest' is not null or undefined
            assertParamExists('bulkUpdateRequirementsControls', 'bulkUpdateControlRequest', bulkUpdateControlRequest)
            const localVarPath = `/requirements/{requirement_id}/controls`
                .replace('{requirement_id}', encodeURIComponent(String(requirementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateControlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Requirement Comments
         * @param {string} requirementId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRequirementComments: async (requirementId: string, addCommentRequest: AddCommentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requirementId' is not null or undefined
            assertParamExists('createRequirementComments', 'requirementId', requirementId)
            // verify required parameter 'addCommentRequest' is not null or undefined
            assertParamExists('createRequirementComments', 'addCommentRequest', addCommentRequest)
            const localVarPath = `/requirements/{requirement_id}/comments`
                .replace('{requirement_id}', encodeURIComponent(String(requirementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Requirement
         * @param {string} requirementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequirement: async (requirementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requirementId' is not null or undefined
            assertParamExists('getRequirement', 'requirementId', requirementId)
            const localVarPath = `/requirements/{requirement_id}`
                .replace('{requirement_id}', encodeURIComponent(String(requirementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Requirement Logs
         * @param {string} requirementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequirementLogs: async (requirementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requirementId' is not null or undefined
            assertParamExists('getRequirementLogs', 'requirementId', requirementId)
            const localVarPath = `/requirements/{requirement_id}/logs`
                .replace('{requirement_id}', encodeURIComponent(String(requirementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get mapped frameworks for a requirement.
         * @summary Get Requirement Mapped Frameworks
         * @param {string} requirementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequirementMappedFrameworks: async (requirementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requirementId' is not null or undefined
            assertParamExists('getRequirementMappedFrameworks', 'requirementId', requirementId)
            const localVarPath = `/requirements/{requirement_id}/mapped-frameworks`
                .replace('{requirement_id}', encodeURIComponent(String(requirementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Requirements Comments
         * @param {string} requirementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequirementsComments: async (requirementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requirementId' is not null or undefined
            assertParamExists('getRequirementsComments', 'requirementId', requirementId)
            const localVarPath = `/requirements/{requirement_id}/comments`
                .replace('{requirement_id}', encodeURIComponent(String(requirementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Requirements Controls
         * @param {string} requirementId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ControlsSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [assignedToId] 
         * @param {string | null} [frameworkCode] 
         * @param {string | null} [name] 
         * @param {ControlStatus | null} [status] 
         * @param {boolean | null} [assessed] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequirementsControls: async (requirementId: string, page?: number, size?: number, sortBy?: ControlsSorting | null, descending?: boolean | null, assignedToId?: string | null, frameworkCode?: string | null, name?: string | null, status?: ControlStatus | null, assessed?: boolean | null, exactMatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requirementId' is not null or undefined
            assertParamExists('getRequirementsControls', 'requirementId', requirementId)
            const localVarPath = `/requirements/{requirement_id}/controls`
                .replace('{requirement_id}', encodeURIComponent(String(requirementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (assignedToId !== undefined) {
                localVarQueryParameter['assigned_to_id'] = assignedToId;
            }

            if (frameworkCode !== undefined) {
                localVarQueryParameter['framework_code'] = frameworkCode;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (assessed !== undefined) {
                localVarQueryParameter['assessed'] = assessed;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Requirement Ownership
         * @param {string} requirementId 
         * @param {UpdateRequirementOwnershipRequest} updateRequirementOwnershipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRequirementOwnership: async (requirementId: string, updateRequirementOwnershipRequest: UpdateRequirementOwnershipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requirementId' is not null or undefined
            assertParamExists('updateRequirementOwnership', 'requirementId', requirementId)
            // verify required parameter 'updateRequirementOwnershipRequest' is not null or undefined
            assertParamExists('updateRequirementOwnership', 'updateRequirementOwnershipRequest', updateRequirementOwnershipRequest)
            const localVarPath = `/requirements/{requirement_id}/owner`
                .replace('{requirement_id}', encodeURIComponent(String(requirementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRequirementOwnershipRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Requirement Status
         * @param {string} requirementId 
         * @param {UpdateRequirementStatusRequest} updateRequirementStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRequirementStatus: async (requirementId: string, updateRequirementStatusRequest: UpdateRequirementStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requirementId' is not null or undefined
            assertParamExists('updateRequirementStatus', 'requirementId', requirementId)
            // verify required parameter 'updateRequirementStatusRequest' is not null or undefined
            assertParamExists('updateRequirementStatus', 'updateRequirementStatusRequest', updateRequirementStatusRequest)
            const localVarPath = `/requirements/{requirement_id}/status`
                .replace('{requirement_id}', encodeURIComponent(String(requirementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRequirementStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RequirementsApi - functional programming interface
 */
export const RequirementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RequirementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Bulk Update Requirements Controls
         * @param {string} requirementId 
         * @param {BulkUpdateControlRequest} bulkUpdateControlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateRequirementsControls(requirementId: string, bulkUpdateControlRequest: BulkUpdateControlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateRequirementsControls(requirementId, bulkUpdateControlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequirementsApi.bulkUpdateRequirementsControls']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Requirement Comments
         * @param {string} requirementId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRequirementComments(requirementId: string, addCommentRequest: AddCommentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Comment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRequirementComments(requirementId, addCommentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequirementsApi.createRequirementComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Requirement
         * @param {string} requirementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRequirement(requirementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Requirement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRequirement(requirementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequirementsApi.getRequirement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Requirement Logs
         * @param {string} requirementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRequirementLogs(requirementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Log>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRequirementLogs(requirementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequirementsApi.getRequirementLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get mapped frameworks for a requirement.
         * @summary Get Requirement Mapped Frameworks
         * @param {string} requirementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRequirementMappedFrameworks(requirementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Framework>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRequirementMappedFrameworks(requirementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequirementsApi.getRequirementMappedFrameworks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Requirements Comments
         * @param {string} requirementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRequirementsComments(requirementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Comment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRequirementsComments(requirementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequirementsApi.getRequirementsComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Requirements Controls
         * @param {string} requirementId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {ControlsSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [assignedToId] 
         * @param {string | null} [frameworkCode] 
         * @param {string | null} [name] 
         * @param {ControlStatus | null} [status] 
         * @param {boolean | null} [assessed] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRequirementsControls(requirementId: string, page?: number, size?: number, sortBy?: ControlsSorting | null, descending?: boolean | null, assignedToId?: string | null, frameworkCode?: string | null, name?: string | null, status?: ControlStatus | null, assessed?: boolean | null, exactMatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRequirementsControls(requirementId, page, size, sortBy, descending, assignedToId, frameworkCode, name, status, assessed, exactMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequirementsApi.getRequirementsControls']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Requirement Ownership
         * @param {string} requirementId 
         * @param {UpdateRequirementOwnershipRequest} updateRequirementOwnershipRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRequirementOwnership(requirementId: string, updateRequirementOwnershipRequest: UpdateRequirementOwnershipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Requirement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRequirementOwnership(requirementId, updateRequirementOwnershipRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequirementsApi.updateRequirementOwnership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Requirement Status
         * @param {string} requirementId 
         * @param {UpdateRequirementStatusRequest} updateRequirementStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRequirementStatus(requirementId: string, updateRequirementStatusRequest: UpdateRequirementStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Requirement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRequirementStatus(requirementId, updateRequirementStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequirementsApi.updateRequirementStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RequirementsApi - factory interface
 */
export const RequirementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RequirementsApiFp(configuration)
    return {
        /**
         * 
         * @summary Bulk Update Requirements Controls
         * @param {RequirementsApiBulkUpdateRequirementsControlsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateRequirementsControls(requestParameters: RequirementsApiBulkUpdateRequirementsControlsRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.bulkUpdateRequirementsControls(requestParameters.requirementId, requestParameters.bulkUpdateControlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Requirement Comments
         * @param {RequirementsApiCreateRequirementCommentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRequirementComments(requestParameters: RequirementsApiCreateRequirementCommentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Comment> {
            return localVarFp.createRequirementComments(requestParameters.requirementId, requestParameters.addCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Requirement
         * @param {RequirementsApiGetRequirementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequirement(requestParameters: RequirementsApiGetRequirementRequest, options?: RawAxiosRequestConfig): AxiosPromise<Requirement> {
            return localVarFp.getRequirement(requestParameters.requirementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Requirement Logs
         * @param {RequirementsApiGetRequirementLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequirementLogs(requestParameters: RequirementsApiGetRequirementLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Log>> {
            return localVarFp.getRequirementLogs(requestParameters.requirementId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get mapped frameworks for a requirement.
         * @summary Get Requirement Mapped Frameworks
         * @param {RequirementsApiGetRequirementMappedFrameworksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequirementMappedFrameworks(requestParameters: RequirementsApiGetRequirementMappedFrameworksRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Framework>> {
            return localVarFp.getRequirementMappedFrameworks(requestParameters.requirementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Requirements Comments
         * @param {RequirementsApiGetRequirementsCommentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequirementsComments(requestParameters: RequirementsApiGetRequirementsCommentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Comment>> {
            return localVarFp.getRequirementsComments(requestParameters.requirementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Requirements Controls
         * @param {RequirementsApiGetRequirementsControlsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequirementsControls(requestParameters: RequirementsApiGetRequirementsControlsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ControlPaginated> {
            return localVarFp.getRequirementsControls(requestParameters.requirementId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.assignedToId, requestParameters.frameworkCode, requestParameters.name, requestParameters.status, requestParameters.assessed, requestParameters.exactMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Requirement Ownership
         * @param {RequirementsApiUpdateRequirementOwnershipRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRequirementOwnership(requestParameters: RequirementsApiUpdateRequirementOwnershipRequest, options?: RawAxiosRequestConfig): AxiosPromise<Requirement> {
            return localVarFp.updateRequirementOwnership(requestParameters.requirementId, requestParameters.updateRequirementOwnershipRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Requirement Status
         * @param {RequirementsApiUpdateRequirementStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRequirementStatus(requestParameters: RequirementsApiUpdateRequirementStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<Requirement> {
            return localVarFp.updateRequirementStatus(requestParameters.requirementId, requestParameters.updateRequirementStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkUpdateRequirementsControls operation in RequirementsApi.
 */
export interface RequirementsApiBulkUpdateRequirementsControlsRequest {
    readonly requirementId: string

    readonly bulkUpdateControlRequest: BulkUpdateControlRequest
}

/**
 * Request parameters for createRequirementComments operation in RequirementsApi.
 */
export interface RequirementsApiCreateRequirementCommentsRequest {
    readonly requirementId: string

    readonly addCommentRequest: AddCommentRequest
}

/**
 * Request parameters for getRequirement operation in RequirementsApi.
 */
export interface RequirementsApiGetRequirementRequest {
    readonly requirementId: string
}

/**
 * Request parameters for getRequirementLogs operation in RequirementsApi.
 */
export interface RequirementsApiGetRequirementLogsRequest {
    readonly requirementId: string
}

/**
 * Request parameters for getRequirementMappedFrameworks operation in RequirementsApi.
 */
export interface RequirementsApiGetRequirementMappedFrameworksRequest {
    readonly requirementId: string
}

/**
 * Request parameters for getRequirementsComments operation in RequirementsApi.
 */
export interface RequirementsApiGetRequirementsCommentsRequest {
    readonly requirementId: string
}

/**
 * Request parameters for getRequirementsControls operation in RequirementsApi.
 */
export interface RequirementsApiGetRequirementsControlsRequest {
    readonly requirementId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: ControlsSorting | null

    readonly descending?: boolean | null

    readonly assignedToId?: string | null

    readonly frameworkCode?: string | null

    readonly name?: string | null

    readonly status?: ControlStatus | null

    readonly assessed?: boolean | null

    readonly exactMatch?: boolean
}

/**
 * Request parameters for updateRequirementOwnership operation in RequirementsApi.
 */
export interface RequirementsApiUpdateRequirementOwnershipRequest {
    readonly requirementId: string

    readonly updateRequirementOwnershipRequest: UpdateRequirementOwnershipRequest
}

/**
 * Request parameters for updateRequirementStatus operation in RequirementsApi.
 */
export interface RequirementsApiUpdateRequirementStatusRequest {
    readonly requirementId: string

    readonly updateRequirementStatusRequest: UpdateRequirementStatusRequest
}

/**
 * RequirementsApi - object-oriented interface
 */
export class RequirementsApi extends BaseAPI {
    /**
     * 
     * @summary Bulk Update Requirements Controls
     * @param {RequirementsApiBulkUpdateRequirementsControlsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkUpdateRequirementsControls(requestParameters: RequirementsApiBulkUpdateRequirementsControlsRequest, options?: RawAxiosRequestConfig) {
        return RequirementsApiFp(this.configuration).bulkUpdateRequirementsControls(requestParameters.requirementId, requestParameters.bulkUpdateControlRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Requirement Comments
     * @param {RequirementsApiCreateRequirementCommentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createRequirementComments(requestParameters: RequirementsApiCreateRequirementCommentsRequest, options?: RawAxiosRequestConfig) {
        return RequirementsApiFp(this.configuration).createRequirementComments(requestParameters.requirementId, requestParameters.addCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Requirement
     * @param {RequirementsApiGetRequirementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRequirement(requestParameters: RequirementsApiGetRequirementRequest, options?: RawAxiosRequestConfig) {
        return RequirementsApiFp(this.configuration).getRequirement(requestParameters.requirementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Requirement Logs
     * @param {RequirementsApiGetRequirementLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRequirementLogs(requestParameters: RequirementsApiGetRequirementLogsRequest, options?: RawAxiosRequestConfig) {
        return RequirementsApiFp(this.configuration).getRequirementLogs(requestParameters.requirementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get mapped frameworks for a requirement.
     * @summary Get Requirement Mapped Frameworks
     * @param {RequirementsApiGetRequirementMappedFrameworksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRequirementMappedFrameworks(requestParameters: RequirementsApiGetRequirementMappedFrameworksRequest, options?: RawAxiosRequestConfig) {
        return RequirementsApiFp(this.configuration).getRequirementMappedFrameworks(requestParameters.requirementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Requirements Comments
     * @param {RequirementsApiGetRequirementsCommentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRequirementsComments(requestParameters: RequirementsApiGetRequirementsCommentsRequest, options?: RawAxiosRequestConfig) {
        return RequirementsApiFp(this.configuration).getRequirementsComments(requestParameters.requirementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Requirements Controls
     * @param {RequirementsApiGetRequirementsControlsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRequirementsControls(requestParameters: RequirementsApiGetRequirementsControlsRequest, options?: RawAxiosRequestConfig) {
        return RequirementsApiFp(this.configuration).getRequirementsControls(requestParameters.requirementId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.assignedToId, requestParameters.frameworkCode, requestParameters.name, requestParameters.status, requestParameters.assessed, requestParameters.exactMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Requirement Ownership
     * @param {RequirementsApiUpdateRequirementOwnershipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateRequirementOwnership(requestParameters: RequirementsApiUpdateRequirementOwnershipRequest, options?: RawAxiosRequestConfig) {
        return RequirementsApiFp(this.configuration).updateRequirementOwnership(requestParameters.requirementId, requestParameters.updateRequirementOwnershipRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Requirement Status
     * @param {RequirementsApiUpdateRequirementStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateRequirementStatus(requestParameters: RequirementsApiUpdateRequirementStatusRequest, options?: RawAxiosRequestConfig) {
        return RequirementsApiFp(this.configuration).updateRequirementStatus(requestParameters.requirementId, requestParameters.updateRequirementStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

